import WorkoutCard from "./workout-card";

export default WorkoutCard;